import { Tabs, TabsContent, TabsList, TabsTrigger } from '@fortem-monorepo/react-ui'

import { Page } from '@/components/Page'
import { OPERATIONS } from '@/constants/links'

import { AccruedInterestActionsProvider } from './AccruedInterestActions'
import { useAccruedInterestActions } from './AccruedInterestActions.context'
import { AccruedInterestsProvider } from './AccruedInterests'
import { useAccruedInterestsContext } from './AccruedInterests.context'
import { AccruedBalanceChartTab } from './components/AccruedBalanceChartTab'
import { AccruedBalancesTab } from './components/AccruedBalancesTab'
import { AccruedInterestGuide } from './components/AccruedInterestGuide'
import { AccruedInterestToolbar } from './components/AccruedInterestToolbar'
import { DailyAccruedTab } from './components/DailyAccruedTab'
import { EmailChartButton } from './components/EmailChartButton'

const AccruedInterestTabs = () => {
  const { actionState } = useAccruedInterestActions()
  const { activeTab, setActiveTab } = useAccruedInterestsContext()
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} className="min-h-0 min-w-0 flex-1 gap-0 overflow-hidden">
      <div className="m-2 flex shrink-0 flex-wrap items-center gap-3">
        <TabsList className="shrink-0">
          <TabsTrigger value="daily" disabled={!!actionState}>
            Daily accrued interests
          </TabsTrigger>
          <TabsTrigger value="balances" disabled={!!actionState}>
            Accrued interest balances
          </TabsTrigger>
          <TabsTrigger value="chart" disabled={!!actionState}>
            Balances As Chart
          </TabsTrigger>
        </TabsList>
        {activeTab === 'chart' && <EmailChartButton />}
      </div>
      <TabsContent value="daily" className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <DailyAccruedTab />
      </TabsContent>
      <TabsContent value="chart" className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <AccruedBalanceChartTab />
      </TabsContent>
      <TabsContent value="balances" className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
        <AccruedBalancesTab />
      </TabsContent>
    </Tabs>
  )
}

export const AccruedInterestsPage = () => (
  <Page
    metadata={{ title: OPERATIONS.ACCRUED_INTERESTS.label }}
    permissions={OPERATIONS.ACCRUED_INTERESTS.permissions}
    layout="fill"
  >
    <AccruedInterestsProvider>
      <AccruedInterestActionsProvider>
        <div className="flex min-h-0 min-w-0 flex-1 flex-col overflow-hidden">
          <AccruedInterestToolbar />
          <AccruedInterestGuide />
          <AccruedInterestTabs />
        </div>
      </AccruedInterestActionsProvider>
    </AccruedInterestsProvider>
  </Page>
)
